<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-form-item label='用户账号'>
              <a-input :placeholder="$t('enter') + '用户账号 '"
                       v-model='queryParam.userPhone'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <a-form-item label='话机账号'>
              <a-input :placeholder="$t('enter') + ' 话机账号'"
                       v-model='queryParam.sipPhone'></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
                      <a-button type='primary' @click='openAddEditModal()' icon='plus-square'
                                style='margin-left: 8px'>新增</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <template slot='action' slot-scope='text, record'>
          <a @click='openEditModal(record)'>编辑</a>
          <a style='margin-left: 20px' @click='opendeleteModal(record)'>删除</a>
        </template>
        <template slot='status' slot-scope='text, record'>
          <div v-if='text == 1'>
            有效
          </div>
          <div v-else>
            无效
          </div>
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
      <v-modal style='width: 300px;' v-model='visible' title='编辑'>
        <div style='padding: 20px;'>
          <a-form :form='dataform' :label-col='{ span: 5 }' :wrapper-col='{ span: 12 }'>
            <a-form-item label='用户账号'>
              <a-input @change='userPhonechange'
                       disabled='disabled'
                       v-decorator="['userPhone', { rules: [{ required: true, message: '请输入用户账号!' }] }]"
              />
            </a-form-item>
            <a-form-item label='话机账号'>
              <a-input @change='sipPhonechange'
                       v-decorator="['sipPhone', { rules: [{ required: true, message: '请输入话机账号!' }] }]"
              />
            </a-form-item>
            <a-form-item label='渠道'>
              <a-input @change='channelchange'
                       v-decorator="['channel', { rules: [{ required: true, message: '请输入渠道!' }] }]"
              />
            </a-form-item>
            <a-form-item label='状态'>
              <a-select
                v-decorator="['status', { rules: [{ required: true, message: '请选择状态!' }] }]"
                placeholder='请选择状态！'
                @change='handleSelectChange'
              >
                <a-select-option value='有效'>有效</a-select-option>
                <a-select-option value='无效'>无效</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :wrapper-col='{ span: 12, offset: 5 }'>
              <a-button @click='handleSubmit' type='primary' html-type='submit'>提交</a-button>
            </a-form-item>
          </a-form>
        </div>
      </v-modal>
      <a-modal
        title='编辑'
        :visible='addvisible'
        :confirm-loading='deleteconfirmLoading'
        @ok='addhandleSubmit'
        @cancel='addvisibleCancel'
      >
        <a-form :form='addFormData' :label-col='{ span: 5 }' :wrapper-col='{ span: 12 }'>
          <a-form-item label='用户账号'>
            <a-select
             v-model='addFormData.userId'
              placeholder='请选择用户账号！'
              @change='adduserIdChange'
              showSearch
              allowClear
            >
              <a-select-option v-for='item in userIDList' :key='item.key' :value='item.value.id'>
                {{ item.value.userName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label='话机账号'>
            <a-input @change='addsipPhonechange'
                     v-model='addFormData.sipPhone'
            />
          </a-form-item>
          <a-form-item label='渠道'>
            <a-input @change='addchannelchange'
                     v-model='addFormData.channel'
            />
          </a-form-item>
          <a-form-item label='状态'>
            <a-select
              v-model='addFormData.status'
              placeholder='请选择状态！'
              @change='addhandleSelectChange'
              showSearch
              allowClear
            >
              <a-select-option value='有效'>有效</a-select-option>
              <a-select-option value='无效'>无效</a-select-option>
            </a-select>
          </a-form-item>

<!--          <a-form-item :wrapper-col='{ span: 12, offset: 5 }'>-->
<!--            <a-button @click='addhandleSubmit' type='primary' html-type='submit'>提交</a-button>-->
<!--          </a-form-item>-->
        </a-form>

      </a-modal>

      <a-modal
        title='删除'
        :visible='deletevisible'
        :confirm-loading='deleteconfirmLoading'
        @ok='deletehandleOk'
        @cancel='deletehandleCancel'
      >
        <p>确定要删除吗？</p>
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getcollectionPhoneAccountLogList,
  updatecollectionPhoneAccountLogList,
  deletecollectionPhoneAccountLogList,
  insertcollectionPhoneAccountLogList
} from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import OrderDetail from '@/views/webpublic/order/OrderDetail.vue'
import vModal from '@/views/webpublic/modules/Modal.vue'
import { getselectXsUserNameList } from '@/webpublicapi/collection'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    vModal, OrderDetail,
    Dict,
    DictSelect
  },
  data() {
    return {
      deletdId: '',
      deletevisible: false,
      deleteconfirmLoading: false,
      addvisible: false,
      dataform: this.$form.createForm(this, { name: 'dataform' }),
      adddataform: this.$form.createForm(this, { name: 'adddataform' }),
      userIDList: [],
      updateFormData: {
        userPhone: '',
        sipPhone: '',
        channel: '',
        status: '',
        id: '',
        userId: ''
      },
      addFormData: {
        sipPhone: '',
        channel: '',
        status: '',
        userId: ''
      },
      paramsVal: {},
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      queryParam: {
        userPhone: '',
        sipPhone: ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '用户编号',
          align: 'left',
          dataIndex: 'userId'
        },
        {
          title: '用户姓名',
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: '用户账号',
          align: 'left',
          dataIndex: 'userPhone'
        },
        {
          title: '话机账号',
          align: 'left',
          dataIndex: 'sipPhone'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel'
        },
        {
          title: '状态',
          align: 'left',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    //
    getselectXsUserNameList().then(res => {
      console.log('res-->', res.data)
      let keys = Object.keys(res.data)
      for (const key of keys) {
        this.userIDList.push({
          key: key,// s1test1
          value: res.data[key]
        })
      }
      console.log('催收员res--->this.userIDList ', this.userIDList)
    })
  },
  methods: {

    // 更新操作
    handleSelectChange(e) {
      this.updateFormData.status = e
    },
    userPhonechange(e) {
      this.updateFormData.userPhone = e.target.value
    },
    sipPhonechange(e) {
      this.updateFormData.sipPhone = e.target.value
    },
    channelchange(e) {
      this.updateFormData.channel = e.target.value
    },
    handleSubmit(e) {
      // console.log('点击了表单提交!!!', this.updateFormData)
      if (this.updateFormData.sipPhone &&
        this.updateFormData.userPhone &&
        this.updateFormData.channel &&
        this.updateFormData.status) {

        console.log('可以请求')
        this.updateFormData.status = this.updateFormData.status === '有效' ? 1 : 0
        const params = this.updateFormData
        updatecollectionPhoneAccountLogList(
          params
        ).then((res) => {
          if (res.code === 1000) {
            this.$message.success(e.message)
            this.visible = false
            this.loadData(1)
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        console.log('有必填项目未填写')
      }

    },
    opendeleteModal(val) {
      this.deletdId = val.id
      console.log('val', val)
      this.deletevisible = true
    },
    deletehandleOk(e) {
      this.deleteconfirmLoading = true
      //接口
      deletecollectionPhoneAccountLogList(
        { id: this.deletdId }
      ).then((res) => {
        console.log('删除的res', res)
        if (res.code === 1000) {
          setTimeout(() => {
            this.deletevisible = false
            this.deleteconfirmLoading = false
            this.loadData(1)
          }, 1000)
        }
      }).catch(e => {
        this.$message.error(e.message)
      })

    },
    deletehandleCancel(e) {
      this.deletevisible = false
    },
    addvisibleCancel(e) {
      this.addvisible = false
    },
    openEditModal(val) {
      this.updateFormData.userPhone = val.userPhone
      this.updateFormData.sipPhone = val.sipPhone
      this.updateFormData.channel = val.channel
      this.updateFormData.status = val.status === 1 ? '有效' : '无效'
      this.updateFormData.id = val.id
      this.updateFormData.userId = val.userId

      this.visible = true
      this.$nextTick(() => {
        this.dataform.setFieldsValue({
          userPhone: this.updateFormData.userPhone,
          sipPhone: this.updateFormData.sipPhone,
          channel: this.updateFormData.channel,
          status: this.updateFormData.status,
          id: this.updateFormData.id,
          userId: this.updateFormData.userId
        })
      })
    },
    // 更新操作结束


    //添加
    addhandleSelectChange(e) {
      // console.log('选择了状态!!!', e)
      this.addFormData.status = e
    },
    adduserIdChange(e) {
      // console.log('选择了用户编号!!!', e)
      this.addFormData.userId = e
    },
    // adduserPhonechange(e) {
    //   // console.log('用户账号!!!', e)
    //   this.addFormData.userPhone = e.target.value
    // },
    addsipPhonechange(e) {
      // console.log('话机账号!!!', e)
      this.addFormData.sipPhone = e.target.value
    },
    addchannelchange(e) {
      // console.log('渠道!!!', e)
      this.addFormData.channel = e.target.value
    },
    openAddEditModal() {
      this.clearaddInfo()
      console.log('点击了新增')
      this.addvisible = true

    },
    clearaddInfo(){
      this.$set(this.addFormData, 'sipPhone', '');
      this.$set(this.addFormData, 'channel', '');
      this.$set(this.addFormData, 'status', '');
      this.$set(this.addFormData, 'userId', '');
    },
    addhandleSubmit(e) {
      console.log('点击了新增添加表单提交!!!', this.addFormData)
      if (this.addFormData.sipPhone &&
        this.addFormData.channel &&
        this.addFormData.status && this.addFormData.userId) {
        console.log('可以请求')
        this.addFormData.status = this.addFormData.status === '有效' ? 1 : 0
        const params = this.addFormData
        insertcollectionPhoneAccountLogList(
          params
        ).then((res) => {
          if (res.code === 1000) {
            this.$message.success(e.message)
            this.clearaddInfo()
            this.addvisible = false
            this.loadData(1)
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.$message.error('有必填项目未填写')
      }

    },

    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      var params = this.getQueryParams()
      if (params == null) {

      } else {
        this.loading = true
        getcollectionPhoneAccountLogList(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('res------->', res)
            this.dataSource = res.data.list
            this.total = res.data.total
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      this.paramsVal = {
        ...this.queryParam
      }
      //分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.userPhone = ''
      that.queryParam.orderGenerationDate = []//[moment().add('days'), moment().add('days', 0)]
      that.queryParam.sipPhone = ''
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .ant-modal {
  width: 600px !important;
}
</style>
